import React from "react";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import PhoneIcon from '@mui/icons-material/Phone';
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">BMS Dashboard</div>
        
        {/* Hotline */}
        <div className="footer-hotline">
          <PhoneIcon fontSize="small" />
          <span>Hotline: </span>
          <a href="tel:+94743020154" className="hotline-link">
            +94 74 3020 154
          </a>
        </div>

        {/* Social Media Icons */}
        <div className="footer-socials">
          <a href="https://facebook.com/renewaa.energy" target="_blank" rel="noopener noreferrer">
            <FacebookIcon className="social-icon" />
          </a>
          <a href="https://www.instagram.com/renewaa.energy/" target="_blank" rel="noopener noreferrer">
            <InstagramIcon className="social-icon" />
          </a>
          <a href="https://www.renewaa.com" target="_blank" rel="noopener noreferrer">
            <LanguageIcon className="social-icon" />
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} BMS Dashboard. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
